import React, { useState } from 'react';
import { M } from '@dashboard-experience/mastodon';
import { Translate as T } from 'react-redux-i18n';
import { CandidateStories, PromptGroup } from 'types/candidateStories';
import { SearchRecord } from 'types/record';
import { CandidateStoryHeader, TranslatedParagraph } from '../../../Common';
import CandidateStorySummaryItem from './CandidateStorySummaryItem';
import CandidateStoryPromptSummary from './CandidateStoryPromptSummary/Container';

import { CANS_STEP_REVIEW } from '../../../../../../../../../constants';

type Props = {
  candidateStories: CandidateStories;
  companyName: string;
  generalInformationOnly: boolean;
  selectedRecords: SearchRecord[];
  switchToChargeSelection: () => void;
  passAcknowledged: () => void;
  promptGroups?: PromptGroup[];
};

const CandidateStorySummary = ({
  passAcknowledged,
  candidateStories,
  companyName,
  generalInformationOnly,
  selectedRecords,
  switchToChargeSelection,
  promptGroups,
}: Props) => {
  const summaryItems = Object.keys(candidateStories).filter(
    key => key !== 'content',
  );

  const [acknowledged, setAcknowledged] = useState(false);

  const handleChange = () => {
    setAcknowledged(true);
    passAcknowledged();
  };

  const hasPromptGroups = promptGroups !== undefined;

  return (
    <div>
      <CandidateStoryHeader step={CANS_STEP_REVIEW} />
      <div>
        <h1 className='mb-2'>
          <T value='components.Report.CandidateStories.steps.review_and_share.title' />
        </h1>
        <TranslatedParagraph
          value='components.Report.CandidateStories.Modal.Confirm.beforeYouProvide'
          interpolationValues={{
            company: companyName,
          }}
        />

        {hasPromptGroups ? (
          <div data-testid='candidate-story-prompt-summary-items'>
            <CandidateStoryPromptSummary
              candidateStories={candidateStories}
              selectedRecords={selectedRecords}
              promptGroups={promptGroups}
            />
          </div>
        ) : (
          <div data-testid='candidate-story-legacy-summary-items'>
            {summaryItems.map(item => {
              const record = selectedRecords.find(r => {
                return r.id === item;
              });

              return (
                <CandidateStorySummaryItem
                  candidateStories={candidateStories}
                  type={item}
                  key={item}
                  record={record}
                />
              );
            })}
          </div>
        )}

        {!generalInformationOnly && (
          <div className='mb-2'>
            <M.Button
              data-testid='add-another-document-button'
              type='button'
              kind='secondary'
              onClick={switchToChargeSelection}
            >
              <T value='components.Report.CandidateStories.Modal.addAnotherRecord' />
            </M.Button>
          </div>
        )}
        <div>
          <M.Checkbox
            data-testid='acknowledge-non-dispute-checkbox'
            id='acknowledge-non-dispute-checkbox'
            role='checkbox'
            checked={acknowledged}
            labelText={
              <T
                value='components.Report.CandidateStories.Modal.Confirm.helpCenterLink'
                dangerousHTML
              />
            }
            onChange={() => handleChange()}
            passAcknowledged={passAcknowledged}
          />
        </div>
      </div>
    </div>
  );
};

export default CandidateStorySummary;
